import {Injectable, NgZone} from '@angular/core';
import {NativeService} from './native.service';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {SessionService} from './session.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../app/app.state';
import {AlarmsService} from './alarms.service';
import {UrlService} from './url.service';

@Injectable({
  providedIn: 'root',
})
export class NativeWebService extends NativeService {

  constructor(
    protected http: HttpClient,
    protected session: SessionService,
    protected store: Store<AppState>,
    protected alarmsService: AlarmsService,
    protected urlService: UrlService,
    protected ngZone: NgZone,
  ) {
    super(http, session, store, alarmsService, urlService, ngZone);
  }


  hideKeyboard(): void {
  }


  clipboardWrite(value: string) {
    navigator.clipboard.writeText(value);
  }


  isNativeSmartphone(): boolean {
    return false;
  }


  hideSplash() {
  }


  runPushRegistration(): Observable<boolean> {
    return new Observable<boolean>((s) => {
      s.next(true);
      s.complete();
    });
  }


  hideStatusBar(): void {
    // noop
  }


  showStatusBar(): void {
    // noop
  }


  //
  // requestPushPermission(): Observable<boolean> {
  //   return new Observable<boolean>((o) => {
  //     o.next(true);
  //     o.complete();
  //   });
  // }
}
